module.exports = new __parcel__URL__("post-incident-reviewsDark.1fbf276d.svg").toString();